import { Entity, EntityMap } from '../types';

export enum DismissablePromptKey {
  FirstRunAnalyticsBubble = 'FirstRunAnalyticsBubble',
  FirstRunExperience = 'FirstRunExperience',
  FirstRunExperienceReplyUpvote = 'FirstRunExperienceReplyUpvote',
  FirstRunExperienceStoryline = 'FirstRunExperienceStoryline',
  FirstRunExperienceStorylineInVivaEngage = 'FirstRunExperienceStorylineInVivaEngage',
  InclusiveReactions = 'InclusiveReactions',
  LeadersDirectoryConnectedLeaders = 'LeadersDirectoryConnectedLeaders',
  LeadersDirectoryFollowedLeaders = 'LeadersDirectoryFollowedLeaders',
  LeadersDirectoryAllLeaders = 'LeadersDirectoryAllLeaders',
  LightboxFollowUsers = 'LightboxFollowUsers',
  LightboxJoinGroups = 'LightboxJoinGroups',
  LockedAchievementsFRE = 'LockedAchievementsFRE',
  MobileUpsell = 'MobileUpsell',
  NetworkQuestionsOnboarding = 'NetworkQuestionsOnboarding',
  OutlookEngageRebrandingBanner = 'OutlookEngageRebrandingBanner',
  OutlookAnswersDigestBanner = 'OutlookAnswersDigestBanner',
  PublisherSaveAsDraftPrompt = 'PublisherSaveAsDraftPrompt',
  PushNotifications = 'PushNotifications',
  PWAInstall = 'PWAInstall',
  StorylineDigestCoachingBar = 'StorylineDigestCoachingBar',
  StorylineAnnouncementTeachingBubble = 'StorylineAnnouncementTeachingBubble',
  VivaEngageFRE = 'VivaEngageFRE',
  VivaEngageInOutlookFRE = 'VivaEngageInOutlookFRE',
  VivaEngageRebrandingNonAdminBanner = 'VivaEngageRebrandingNonAdminBanner',
  VivaEngageRebrandingAdminBanner = 'VivaEngageRebrandingAdminBanner',
  VivaEngageRebrandingDialog = 'VivaEngageRebrandingDialog',
}
export interface DismissablePrompt extends Entity {
  readonly isDismissed: boolean;
}

export type DismissablePrompts = EntityMap<DismissablePrompt>;
